export default "__VITE_ASSET__DnnMT5Ix__"